module.exports = __webpack_public_path__ + "img/submitted.2caac77d.png";